import { Box } from "@mui/material";
import styled from "@emotion/styled";
import {
  DoctorBaseAttributes,
  PatientBaseAttributes,
} from "../../../interfaces";
import {
  CardInfoText,
  CardSectionSubtitle,
  GappedCardContainer,
} from "../styles";
import { ObscuredText } from "@components";
import { format as formatDate } from "date-fns";
import { format as formatRut } from "rut.js";
import { separateDoctorSpecialty } from "../../../utils/getDoctorTitle";

type Props = {
  emissionDate: Date;
  doctorData: Omit<DoctorBaseAttributes, "birthdate">;
  patientData: Omit<PatientBaseAttributes, "email" | "phone">;
  showTitle: boolean;
};

const DateContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  gap: "4px",
});

export const GeneralInfoCard: React.FC<Props> = ({
  emissionDate,
  doctorData,
  patientData,
  showTitle,
}) => {
  const { mekidocAccessTitle, specialties } = separateDoctorSpecialty(
    doctorData.speciality
  );
  return (
    <GappedCardContainer>
      {showTitle && (
        <CardSectionSubtitle>Información del documento</CardSectionSubtitle>
      )}
      <DateContainer>
        <CardSectionSubtitle>Fecha emisión: </CardSectionSubtitle>
        <CardInfoText paddingTop={"0px"}>
          {formatDate(emissionDate, "dd/MM/yyyy")}
        </CardInfoText>
      </DateContainer>

      <Box>
        <CardSectionSubtitle>Datos doctor</CardSectionSubtitle>
        <CardInfoText>
          {doctorData.name} {doctorData.lastName}
        </CardInfoText>

        <CardInfoText>{formatRut(doctorData.rut)}</CardInfoText>

        <CardInfoText>
          {mekidocAccessTitle} (REG-SIS N°: {doctorData.registrationNumber})
        </CardInfoText>
        {specialties && <CardInfoText>{specialties}</CardInfoText>}
      </Box>

      <Box>
        <CardSectionSubtitle>Datos paciente</CardSectionSubtitle>

        <ObscuredText component={CardInfoText}>
          {patientData.name} {patientData.firstSurname}{" "}
          {patientData.secondSurname}
        </ObscuredText>

        {patientData.rut && (
          <ObscuredText component={CardInfoText}>
            {formatRut(patientData.rut)}
          </ObscuredText>
        )}

        {patientData.passport && (
          <ObscuredText component={CardInfoText}>
            {patientData.passport}
          </ObscuredText>
        )}
      </Box>
    </GappedCardContainer>
  );
};
